(function () {
  if (typeof window === 'undefined') return;

  // Respect user motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTORS = [
    '.universe-blocks',
    '.reassurance-bar',
    '.editorial-split',
    '.project-gallery',
    '.how-it-works',
    '.surface-calculator',
    '.product-trust-strip',
    '.collection-header',
    '.footer-content',
  ];

  
  function init() {
    const targets = document.querySelectorAll(SELECTORS.join(', '));
    if (!targets.length) return;

    targets.forEach((el) => {
      el.setAttribute('data-etoba-reveal', '');
    });

    if (!('IntersectionObserver' in window)) {
      // Fallback: reveal all immediately
      targets.forEach((el) => el.classList.add('etoba-revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('etoba-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    targets.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section reloads (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
